import type {ReactElement} from 'react';
import type {BrandKitSwatchClusterProps} from './brand-kit-swatch-cluster.types';
import {BrandKitSwatchClusterVariant} from './brand-kit-swatch-cluster.types';
import styles from './brand-kit-swatch-cluster.module.scss';

const CLUSTER_CLASS_BY_VARIANT: Record<BrandKitSwatchClusterVariant, string> = {
  [BrandKitSwatchClusterVariant.DEFAULT]: styles.default,
  [BrandKitSwatchClusterVariant.COMPACT]: styles.compact,
};

export function BrandKitSwatchCluster({logoURL, colorHexes, variant = BrandKitSwatchClusterVariant.DEFAULT}: BrandKitSwatchClusterProps): ReactElement | null {
  const getLogoSwatch = (): ReactElement | null => {
    if (!logoURL) {
      return null;
    }

    return (
      <div className={styles.swatch}>
        <img className={styles.logo} src={logoURL} alt="" />
      </div>
    );
  };

  const getColorSwatches = (): ReactElement[] => {
    return colorHexes.map((colorHex, index) => {
      return <div key={`${colorHex}-${index}`} className={styles.swatch} style={{backgroundColor: colorHex}} />;
    });
  };

  if (!logoURL && colorHexes.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.cluster} ${CLUSTER_CLASS_BY_VARIANT[variant]}`} aria-hidden="true">
      {getLogoSwatch()}
      {getColorSwatches()}
    </div>
  );
}
